import { TransportOrder } from './transport-order.model';
import { DeliveryStepResult } from './delivery-step-result.model';
import { DeliveryStep } from './delivery-step.model';
import { DeliveryStatus, LIST_DELIVERY_STATUS } from './delivery-status.model';
import { LIST_ORDER_REFUND_ERROR, OrderRefundError } from './order-refund-error.model';
import { LIST_REFUNDED_STATUS, OrderRefundedStatus } from './basket-order-refunded-status.model';
import { ColorEnum } from './enums/color.enum';
import { Transport } from './transport.model';

export class TransportOrderView extends TransportOrder {
  public trackAndTrace: DeliveryStepResult;
  public lastPod?: string;
  public pods: DeliveryStep[] = [];
  public lastPodCalled: boolean = false;
  public companyName!: string;
  public refundable?: OrderRefundError;
  public refundedStatus?: OrderRefundedStatus;

  constructor(data: any = {}) {
    super(data);
    this.trackAndTrace = new DeliveryStepResult(data.trackAndTrace);
    this.lastPod = data.lastPod;
    this.pods = data.pods;
    this.lastPodCalled = data.lastPodCalled;
    this.companyName = data.companyName;
    this.offerName = data.offerName;
    this.refundable = data.refundable ? LIST_ORDER_REFUND_ERROR[data.refundable] : undefined;
    this.refundedStatus = data.refundedStatus ? LIST_REFUNDED_STATUS[data.refundedStatus] : undefined;
  }

  public getBadgeStatus(): DeliveryStatus {
    if (this.deliveryStatus && (this.deliveryStatus as DeliveryStatus).code === LIST_DELIVERY_STATUS.CANCELED.code) {
      return LIST_DELIVERY_STATUS.CANCELED;
    }
    if (this.trackAndTrace.errorStepActive) {
      return LIST_DELIVERY_STATUS.PROBLEM;
    }
    if (this.trackAndTrace.stepFiveActive) {
      return LIST_DELIVERY_STATUS.DELIVERED;
    }
    const today = new Date();
    if (this.pickupDate!.isBefore(today) || this.pickupDate!.isSame(today)) {
      return LIST_DELIVERY_STATUS.INTRAVEL;
    }
    if (this.pickupDate!.isAfter(today)) {
      return LIST_DELIVERY_STATUS.INITIAL;
    }
    return this.deliveryStatus as DeliveryStatus;
  }

  public statusBadgeOpts(): { labelKey?: string; color: ColorEnum; emoji?: string; icon?: string; tooltipKey?: string } {
    const deliveryStatus: DeliveryStatus = this.getBadgeStatus();
    return {
      labelKey: deliveryStatus.keyLabel,
      color: deliveryStatus.color,
      emoji: deliveryStatus?.emojis,
    };
  }

  public override serialize(): any {
    const result = super.serialize();
    return {
      ...result,
      trackAndTrace: this.trackAndTrace,
      lastPod: this.lastPod,
      pods: this.pods,
      lastPodCalled: this.lastPodCalled,
      companyName: this.companyName,
      refundable: this.refundable,
      refundedStatus: this.refundedStatus,
    };
  }

  public createTransport(): Transport {
    const data = this.serialize();
    data.id = undefined;
    data.transportExtraConditions = (data.transportExtraConditions || []).map((val: any) => {
      val.id = undefined;
      return val;
    });
    data.items = (data.items || []).map((val: any) => {
      val.id = undefined;
      return val;
    });
    return new Transport(data);
  }
}
